import { render } from "./Contact.vue?vue&type=template&id=5131c88c&scoped=true"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=5131c88c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5131c88c"]])

export default __exports__